import SFetch from '@app/utils/sfetch'
import type { WorkflowListItem } from '@app/shared/types/sf-data'

export function getWorkflows(
  endpointParams: Record<string, unknown>
): Promise<WorkflowListItem[] | null> {
  const params = {
    ...window.Silverfin.jsonParams,
    ...endpointParams,
  }

  const url = window.Silverfin.Routes.list_company_workflows_path(params)

  return SFetch.json<WorkflowListItem[]>(url)
}
